<div class="container" style=" border: 1px solid #0076ce;margin-bottom: 5%;">
    <h2 class="dds__h2" style="font-weight: bold; margin: 1rem;">Attach Files
    </h2>
    <div *ngIf="hasUploadPrivilege" class="tableFixHead_add_row dds__table-striped" style="margin: 1rem;  overflow-x: auto; margin-bottom: 0;">
        <form [formGroup]="attachmentInfoDynamicForm">
        <table class="dds__table">
            <thead>

                <tr>
                    <th>File Codes Filter</th>
                    <th>File Type Codes </th>
                    <th>File Name</th>
                    <th>File Destination</th>
                    <th style="text-align: center;">Digital Sign?</th>
                    <th style="text-align: center;">Actions</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let attachment of t.controls; let i = index">
                <tr>
                    <ng-container [formGroup]="attachment" class="form-row">
                        <td>
                            <select name="fileCodesFilter" aria-label="" class="dds__form-control" id="fileCodesFilter" #fileCodeFilter
                                formControlName="fileCodeFilter" style="width: 10rem;" (change)="onChangeFileCodeFilter()">
                                <option></option>
                                <option *ngFor="let fileCodesFilter of fileCodesFilters" [value]="fileCodesFilter">{{fileCodesFilter}}</option>
                            </select>
                        </td>
                        <td>
                            <select name="fileTypeCodes" aria-label="" class="dds__form-control" id="fileTypeCodes" #fileTypeCode
                                formControlName="fileTypeCode" style="width: 10rem;" (change)="onChangeFileTypeCode(i,false)">
                                <option></option>
                                <option *ngFor="let fileTypeCode of (fileTypeCodeRes | fileTypeFilter:fileCodeFilter.value)"
                                    [value]="fileTypeCode">{{fileTypeCode}}</option>
                            </select>
                        
                        </td>

                    <td *ngIf="accToggleValue" tabindex="-1" style="text-align: left; display: inline-flex;">
                        <app-file-explorer modalId="fileExplorerModal" modalTitleId="fileExplorerModalTitle" index={{i}} fileExtensions={{getFileExtension()}}  fileExtensionString={{getFileExtensionString()}} fileTypeCode={{fileTypeCode.value}} (fileNamePath)="enterFileName($event)"></app-file-explorer>
                        <input type="text" name="fileName" id="fileName" formControlName="fileNameWithPath" placeholder="No file chosen"/>
                    </td>
                    <td *ngIf="!accToggleValue">
                        <input formControlName="fileNameWithPath" type="file" (change)="onFileChange($event,i)">
                    </td>

                    <td>
                        <div style="text-align: left;">
                            <h6 >{{fileCodeFilter.value}}</h6>
                        </div>
                    </td>
                    <td>
                        <div style="text-align: center;">
                            <input  type="checkbox" name="digitalSign" formControlName="digitalSign" >
                        </div>
                    </td>
                    <td style="text-align: center;">
                        <i *ngIf= "i<4" style="font-size: 1.13em; color: #0076ce; cursor: pointer;" tabindex="-1" role="button"
                        aria-label="Add child"
                        class="clickable dds__icons dds__add-cir  bowtie-icon  dds__icon-grid-item"
                        aria-describedby="vss_21" (click)="addChild(i)"></i>
                        &nbsp;
                        <i *ngIf= "i>0" style="font-size: 1.13em; color: #8f0505;" tabindex="-1" role="button"
                        aria-label="Add child"
                        class="clickable dds__icons dds__remove-cir bowtie-icon  dds__icon-grid-item"
                        aria-describedby="vss_21" (click)="removeChild(i)"></i>
                    </td>
                </ng-container>
                </tr>
            </ng-container>
            </tbody>
        </table>
    </form>
    </div>
    <div *ngIf="!hasUploadPrivilege">
        <p style="text-align: center; font-weight: bold;margin: 3rem;">
        No privilege to upload files</p>
    </div>

    <div *ngIf="hasUploadPrivilege" style="display: flex; align-items: center; justify-content: center; margin: 1rem; margin-bottom: 2rem;">
        <button [disabled]="hasUploadPrivilege==false" role="button" type="button" class="dds__btn dds__btn-primary dds__text-truncate" style="margin-right: 1%;" (click)="uploadFiles()">Upload</button>
      </div>

    <div *ngIf="uploadFilesError">
        <p style="margin-left: 1rem;margin-right: 1rem; color: var(--dell-red);">
            Validation Error:<br>           
        </p>
    </div>
    <div *ngFor="let row of fileExtensionRowErr">
        <p style="margin-left: 1rem;margin-right: 1rem; color: var(--dell-red);">
            {{row}}
        </p>

    </div>

</div>
<app-info-modal ng-init="expression" modalId="fromageId1" modalTitleId="fromageTitle1">
    <div modal-close>
        <button style="display:none" class="dds__close" id="closeUploadModal" data-dismiss="dds__modal" aria-label="Close">
            <span class="dds__icons dds__close-x" aria-hidden="true"></span>
        </button>
    </div>
    <div modal-body>
         <div style="text-align: center;">
          <svg style="height: 32px; width: 32px; "> <use xlink:href="#dds__loading-sqrs"></use></svg>
        </div>&nbsp;
         <p style="text-align: center;">{{uploadLoadingModalMessage}}</p> 
    </div>
<span modal-trigger id="uploadprogressbar">
</span>

<div *ngIf="false" class="container" style=" margin: 3rem;">
    <p style="text-align: left;">*No Active Uploads</p>
</div>
</app-info-modal>
